export enum CustomerCardType {
    UTN = 'U',
    UTN2 = 'T',
    EMV = 'E',
    FOREIGN = 'F',
    ISIC = 'V',
    HSL = 'H',
    WALTTI = 'W',
    KOLUMBUS = 'K',
    QR = 'Q',
    BARCODE = 'P',
    UID = 'N'
}
